export default {
  namespaced: true,
  state: {
    showModal: {
      show: false,
      id: null,
      type: "add",
      profile_object: null,
      members: false,
    },
    followerModal: {
      show: false,
      group: null,
    },
    leaveGroupModal: {
      show: false,
      item: {},
    },
  },
  getters: {
    getShow: (state) => state.showModal.show,
    getFollowerShow: (state) => state.followerModal.show,
    getProfileObject: (state) => state.showModal.profile_object,
    getShowLeaveGroup: (state) => state.leaveGroupModal.show,
  },
  mutations: {
    TOGGLE_SHOW_MODAL(state, obj) {
      if (obj.show) {
        state.showModal.id = obj.id ? obj.id : "";
        state.showModal.type = obj.type ? obj.type : "";
        state.showModal.profile_object = obj.profile_object
          ? obj.profile_object
          : null;
        state.showModal.members = obj.members ? obj.members : false;
      }
      state.showModal.show = obj.show;
    },
    TOGGLE_FOLLOWER_MODAL(state, obj) {
      if (obj.show) {
        state.followerModal.group = obj.group ? obj.group : null;
      }
      state.followerModal.show = obj.show;
    },
    showLeaveConfirmationModal(state, obj) {
      state.leaveGroupModal.show = obj.show ? obj.show : false;
      state.leaveGroupModal.item = obj.item ? obj.item : "";
    },
  },
  actions: {
    toggleShowGroupModal({ commit }, obj) {
      commit("TOGGLE_SHOW_MODAL", obj);
    },
    toggleFollowerModal({ commit }, obj) {
      commit("TOGGLE_FOLLOWER_MODAL", obj);
    },
    showLeaveConfirmationModal({ commit }, obj) {
      commit("showLeaveConfirmationModal", obj);
    },
  },
};
